import { render, staticRenderFns } from "./AutopilotBgVideo.vue?vue&type=template&id=cb472a7c&scoped=true&"
import script from "./AutopilotBgVideo.vue?vue&type=script&lang=js&"
export * from "./AutopilotBgVideo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cb472a7c",
  null
  
)

export default component.exports